// Small cross-link tab bar shared by both War Room pages (Scorecard + Planning).
import React from 'react';
import { Link } from 'react-router-dom';

const TABS = [
    { label: 'Scorecard', to: '/war-room' },
    { label: 'Planning', to: '/war-room/planning' },
    { label: 'FC Leaderboard', to: '/war-room/fc-leaderboard' },
    { label: 'Buy Box sources', to: '/war-room/bb-compare' },
];

function WarRoomTabs({ active }) {
    return (
        <div className="flex items-center gap-1 border-b border-gray-200">
            {TABS.map((tab) => {
                const isActive = tab.label === active;
                return (
                    <Link
                        key={tab.label}
                        to={tab.to}
                        className={`px-3 py-2 text-sm font-semibold border-b-2 -mb-px ${
                            isActive
                                ? 'border-blue-600 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                    >
                        {tab.label}
                    </Link>
                );
            })}
        </div>
    );
}

export default WarRoomTabs;
